import { intersection } from "lodash";
import { FunctionComponent, ReactNode, useMemo } from "react";
import { useSelector } from "react-redux";
import { AppStore } from "../store";
import { AuthDTO } from "../store/auth/models/dto";
import { Roles } from "../store/auth/models/internal";
import { Fetchable } from "../store/common/fetchable/helpers";

export const Permission: FunctionComponent<{
  roles: Array<typeof Roles.T>;
  alternative?: ReactNode;
}> = ({ children, alternative, roles }) => {
  const hasPermission = useHasPermission(roles);
  return hasPermission ? <>{children}</> : <>{alternative || null}</>;
};

export const useHasPermission = (roles: Array<typeof Roles.T>) => {
  const authFetchable = useSelector<
    AppStore,
    Fetchable<AuthDTO.Responses.Login.T>
  >((state) => state.auth.login);

  return useMemo(
    () =>
      authFetchable.status === "ready" &&
      intersection(authFetchable.data.accessToken.roles, roles).length > 0,
    [authFetchable, roles]
  );
};
